module.exports = __webpack_public_path__ + "components/flag/static/square/bf-1e7dac0a51139624c56c40a7b2cbbc93.svg";